import * as fetcher from '@hydra/utils/fetcher';

export async function getReviewSnapshots (searchParams: { [key: string]: string }) {
  return fetcher.get('/api/review/snapshots', {
    searchParams
  }).json();
}

export async function getReviewDiff (searchParams: { [key: string]: string }) {
  return fetcher.get('/api/review/diff', {
    searchParams
  }).json();
}

export async function refreshReview ({ url, isFree }: { url: string, isFree?: boolean}) {
  try {
    const uri = isFree ? '/api/free-review/generation' : '/api/review/generation';
    return await fetcher.post(uri, {
      json: { url }
    }).json();
  } catch (err) {
    if (err instanceof fetcher.HTTPError) {
      const { error, ...props } = await err.response.json();
      throw Object.assign(new Error(error), props);
    }
    throw err;
  }
}

export async function getReviewStatus (id: string) {
  return fetcher.get(`/api/review/generation/${id}`).json();
}

export async function getPagesReviewsData (searchParams: { [key: string]: string }) {
  return fetcher.get('/api/review/internal', { searchParams }).json();
}

export async function getReviewData (searchParams: { [key: string]: string }) {
  return fetcher.get('/api/review', { searchParams }).json();
}

export async function deleteReview (url: string) {
  await fetcher.del('/api/reviews', {
    json: { url }
  });
}

export async function createReview (url: string) {
  try {
    return await fetcher.post('/api/review', {
      json: { url }
    }).json();
  } catch (err) {
    if (err instanceof fetcher.HTTPError) {
      const { error, ...props } = await err.response.json();
      throw Object.assign(new Error(error), props);
    }
    throw err;
  }
}

export async function createFreeReview (url: string, refresh = false) {
  try {
    return await fetcher.post('/api/free-review', {
      json: { url, refresh }
    }).json();
  } catch (err) {
    if (err instanceof fetcher.HTTPError) {
      const { error, ...props } = await err.response.json();
      throw Object.assign(new Error(error), props);
    }
    throw err;
  }
}

export async function createPageReview (url: string, domain: string) {
  try {
    return await fetcher.post('/api/page-review', {
      json: { url, domain }
    }).json();
  } catch (err) {
    if (err instanceof fetcher.HTTPError) {
      const { error, ...props } = await err.response.json();
      throw Object.assign(new Error(error), props);
    }
    throw err;
  }
}
